import { ValidationResult as e } from "./index4.js";
import { Messages as h } from "./index5.js";
const t = "Please enter a valid email address.";
class v {
  validate(u, i) {
    if (!i)
      return e.failure(h.getInvalidEmailMessage(u));
    if (i = i.trim().toLowerCase(), i.length === 0)
      return e.failure(h.getInvalidEmailMessage(u));
    const m = '"(\\\\"|[^"])+"', f = "(" + "([/A-Za-z0-9!#%&`_=$'*+?^|~.-])+" + "|" + m + ")", g = new RegExp("^" + f + "(\\." + f + ")*$"), $ = /^[\\[]?(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})[\]]?$/, A = "[A-Za-z0-9-]+", p = /^(.+)@(.+)$/, s = i.match(p);
    if (!s)
      return e.failure(`${t}`);
    const a = s[1], o = s[2];
    for (let r = 0; r < a.length; r++)
      if (a.charCodeAt(r) > 127)
        return e.failure(`${t}`);
    if (a.charCodeAt(0) === 46 || a.charCodeAt(a.length - 1) === 46)
      return e.failure(`${t}`);
    if (a.indexOf("..") !== -1 && (!a.startsWith('"') || !a.endsWith('"')))
      return e.failure(`${t}`);
    if (a.length > 64)
      return e.failure(`${t}`);
    if (o.length > 253)
      return e.failure(`${t}`);
    if (!a.match(g))
      return e.failure(`${t}`);
    const l = o.match($);
    if (l) {
      for (let r = 0; r <= l.length; r++) {
        const d = Number(l[r]);
        if (d > 255 || d < 0)
          return e.failure(`${t}`);
      }
      return e.success();
    }
    const E = new RegExp(
      "^" + A + "$"
    ), n = o.split("."), c = n.length;
    if (c < 2)
      return e.failure(`${t}`);
    for (let r = 0; r < c; r++) {
      if (n[r].search(E) === -1)
        return e.failure(`${t}`);
      if (n[r].length > 63)
        return e.failure(`${t}`);
      if (n[r].charCodeAt(0) === 45 || n[r].charCodeAt(n[r].length - 1) === 45)
        return e.failure(`${t}`);
    }
    return e.success();
  }
}
export {
  v as EmailValidator
};
//# sourceMappingURL=index2.js.map
